/**
 * 지출/수당/선출금 입력 시트 (일지 카드 > 지출)
 *
 * 구 Diary/Main.js 의 전역 add_expances / _renderExpenseFormM / save_accountForm /
 * expase_radioTypesel / account_saveCancel / delete_accountForm / carPlateinput /
 * target_personCheck 이관.
 * (구 _sky_m_05_ajax_gethtml.php get_acccountJob 마크업 재현본을 그대로 들고 왔다.)
 *
 * ⚠ 구현은 스캐폴드의 공용 팝업 상자(#memoinputmore)를 빌려 쓰고 그 노드를 BS 안팎으로
 *   옮겼다 — MY 메모와 상자를 공유해 서로의 잔상·노드 소실을 만들었다. 지금은 자기 마크업을
 *   BS content-area 에 직접 그린다.
 *
 * [호출]
 *   $j.F.Diary.ExpenseForm.open(orderNum, editNum)   // window.add_expances 브리지
 */
import Util from '../../Common/Util';
export default class ExpenseForm {
    open(orderNum, editNum) {
        editNum = parseInt(editNum, 10);
        if (isNaN(editNum)) editNum = 0;
        window.edit_expancess = orderNum;   // 달력 쪽(Calendar.js)이 참조하는 편집중 표식

        $j.Ui.BS.open({
            target: '$j.F.Diary.ExpenseForm',
            fixedHeight: true,
            data: { orderNum, editNum },
        });
        $j.Ui.BS.setTitle(editNum ? '지출 수정' : '지출 입력');
    }

    init() {
        this.$el = $(`#${this.id}`);
        this.$el.html(`<div style="padding:30px 0;text-align:center">${$j.Common.Util.spinnerHtml('jb-spin--fade')}</div>`);
        this.initHandler();
        this.load();
    }

    destroy() {
        this.$el?.off();
    }

    /** 인라인 onclick 대신 위임 — 마크업이 이 모듈 소유다. */
    initHandler() {
        this.$el
            .on('click',  '[data-act="cancel"]', () => this.cancel())
            .on('click',  '[data-act="save"]',   () => this.save())
            .on('click',  '[data-act="del"]',    () => this.remove())
            .on('change', '[data-act="type"]',   (e) => {
                const $r = $(e.currentTarget);
                this.selectType($r.data('type'), $r.data('value'));
            })
            .on('change', '#selectdirver', () => this.syncDriverName())
            .on('change', '#selectcar',    () => this.syncCarPlate());
    }

    load() {
        $.ajax({
            type: 'GET',
            url: '/m/ajax/diary/expense/form',
            data: { ordernum: this.data.orderNum, editNum: this.data.editNum },
        }).done((form) => {
            this.form = form;
            this.$el.html(this.render(form));
            $j.Common.Form.registerNumberHandler('jobprice');
            this.bindDatePicker();
        });
    }

    cancel() {
        window.edit_expancess = 0;
        $j.Ui.BS.close();
    }

    // ── HTML 이스케이프 ──
    _attr(v) { return String(v == null ? '' : v).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/'/g, '&#39;'); }
    _text(v) { return String(v == null ? '' : v).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;'); }

    /**
     * 지출일 — 모비스크롤 달력
     *
     * 구현은 년/월/일 <select> 3개였다(구 common.js Select_get_*_list — 지금은 없다). 큰글씨에서 한 줄에
     * 들어가지 않고, 말일 초과 같은 검증을 저장할 때 따로 해야 했다.
     * 달력탭의 initExpenseDatePicker(Diary/Calendar.js)와 같은 방식.
     */
    bindDatePicker() {
        if (typeof mobiscroll === 'undefined') return;
        const $el = this.$el.find('#occureDate');
        if (!$el.length) return;

        $el.mobiscroll('destroy');
        const inst = $el.mobiscroll().datepicker({
            controls: ['calendar'],
            dateFormat: 'YYYY-MM-DD',
            locale: mobiscroll.localeKo,
            display: 'center',
        }).mobiscroll('getInst');

        $el.off('click.expdate').on('click.expdate', function () {
            const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(this.value);
            if (m) inst.setVal(new Date(+m[1], +m[2] - 1, +m[3]), true);
            $el.mobiscroll('open');
        });
    }

    render(form) {
        if (!form) return '';
        const A = (v) => this._attr(v);
        const T = (v) => this._text(v);

        const row = (label, field, id) =>
            `<div class="dsheet__row"${id ? ` id="${id}"` : ''}>`
            + `<span class="dsheet__lb">${label}</span>`
            + `<span class="dsheet__fd">${field}</span>`
            + '</div>';

        // ── 구분 — 세그먼트 토글(.dseg, 계산서 시트와 같다). 진짜 <input type="radio"> 는 그대로 두고 시각만 대체.
        const TYPES = [[1, '지출', '지출항목'], [2, '수당', '수당'], [3, '선출금', '선출금']];
        const types = TYPES.map(([n, label, value]) =>
            `<label class="dseg__opt"><input type="radio" name="expf_type" value="${n}"`
            + `${form.inputType == value ? ' checked' : ''} data-act="type" data-type="${n}" data-value="${value}">`
            + `<span>${label}</span></label>`).join('');

        // ── 내용(하위분류) — 지출일 때만 '자비지출' 체크박스가 붙는다
        let defOption = "<option value=''>구분을 먼저 고르세요</option>";
        if (form.inputType && form.types && form.types[form.inputType]) {
            form.types[form.inputType].forEach((sub) => {
                defOption += `<option value='${A(sub)}'${sub == form.inputTypeSub ? ' selected' : ''}>${T(sub)}</option>`;
            });
        }
        const contentCell = this._contentCell(defOption, form.inputType == '지출항목', form.expanceIsOnMe == 1);

        let driverOpt = (form.drivers && form.drivers.length) ? "<option value=''>기사선택</option>" : '';
        let selDriverName = '';
        (form.drivers || []).forEach((d) => {
            const sel = (d.num == form.selectedDriver);
            if (sel) selDriverName = d.name;
            driverOpt += `<option value='${d.num}'${sel ? ' selected' : ''}>${T(d.name)}</option>`;
        });
        let orderOpt = "<option value='0'>오더없이 운행</option>";
        (form.orders || []).forEach((o) => { orderOpt += `<option value='${o.num}' selected>${T(o.label)}</option>`; });
        let carOpt = "<option value='0'>차량관련외 입력</option>";
        (form.cars || []).forEach((c) => { carOpt += `<option value='${c.num}'${c.selected ? ' selected' : ''}>${T(c.plate)}</option>`; });

        const memset = (k) => (form.types && form.types[k]) ? form.types[k].join('|') : '';
        const dateVal = form.date
            ? `${form.date.year}-${String(form.date.month).padStart(2, '0')}-${String(form.date.day).padStart(2, '0')}`
            : '';

        // 제목/닫기는 BS 헤더가 들고 있다 (구 마크업의 '지출입력' 제목줄 + position:fixed X 버튼 제거)
        // 순서 — 구분 → 금액(가장 크게) → 무엇을·언제 → 누가·어느 차·어느 오더 → 비고 (스타일 _diary-sheets.scss .expf)
        return ''
            + '<div class="expf">'
            +   `<div class="dseg expf__seg" role="radiogroup" aria-label="구분">${types}</div>`
            +   '<label class="expf__amt"><span class="expf__amt-lb">금액</span>'
            +     `<input type="tel" inputmode="numeric" name="jobprice" id="jobprice" data-amount-kor placeholder="0" value="${form.price ? Util.formatNumber(form.price) : ''}">`
            +     '<span class="expf__amt-unit">원</span></label>'
            +   '<div class="expf__list">'
            +     row('내용', contentCell, 'userexpanceinputHolder')
            //    지출일 — 구 년/월/일 <select> 3개 대신 모비스크롤 달력 (달력탭 initExpenseDatePicker 와 같은 방식)
            +     row('지출일', `<input type="text" id="occureDate" readonly value="${A(dateVal)}"${form.dateEnabled ? '' : ' disabled'}>`)
            +     row('기사', `<select name="selectdirver" id="selectdirver">${driverOpt}</select>`)
            +     row('차량', `<select name="selectcar" id="selectcar">${carOpt}</select>`)
            +     row('오더', `<select name="selectorder" id="selectorder">${orderOpt}</select>`)
            +     row('비고', `<input type="text" name="jobetc" id="jobetc" placeholder="메모 (선택)" value="${A(form.memo)}">`)
            +   '</div>'
            +   '<div class="expf__foot">'
            +     '<button type="button" class="dsheet__btn" data-act="cancel">취소</button>'
            +     (parseInt(form.editNum, 10) > 0 ? '<button type="button" class="dsheet__btn dsheet__btn--danger" data-act="del">삭제</button>' : '')
            +     `<button type="button" class="dsheet__btn dsheet__btn--ok" data-act="save">${T(form.btnLabel)}</button>`
            +   '</div>'
            +   `<input type="hidden" name="inputtype" id="inputtype" value="${A(form.inputType)}">`
            +   `<input type="hidden" id="memsetType1" value="${A(memset('지출항목'))}">`
            +   `<input type="hidden" id="memsetType2" value="${A(memset('수당'))}">`
            +   `<input type="hidden" id="memsetType3" value="${A(memset('선출금'))}">`
            +   '<input type="hidden" name="mynum" id="mynum" value="">'
            +   `<input type="hidden" id="select_drivername" name="select_drivername" value="${A(selDriverName)}">`
            +   `<input type="hidden" id="select_drivernum" name="select_drivernum" value="${form.selectedDriver || ''}">`
            +   `<input type="hidden" id="select_carplatetext" name="select_carplatetext" value="${A(form.workerCarplate)}">`
            +   '<input type="hidden" id="inputmemtype" name="inputmemtype" value="">'
            +   `<input type="hidden" id="mem_ownercode" name="mem_ownercode" value="${form.ownerNum}">`
            +   '<input type="hidden" name="datatype" id="datatype" value="사업">'
            +   `<input type="hidden" name="expanseeditnum" id="expanseeditnum" value="${form.editNum}">`
            +   `<input type="hidden" name="regto_order" id="regto_order" value="${form.regToOrder}">`
            + '</div>';
    }

    /** '내용' select (+ 지출일 때 자비지출 체크박스) */
    _contentCell(optionsHtml, isExp, isOnMe) {
        const sel = `<select name="typemain" id="typemain">${optionsHtml}</select>`;
        if (!isExp) return sel;
        return sel
            + `<label class="expf__chip"><input type="checkbox" id="expances_minset" value="1"${isOnMe ? ' checked' : ''}>`
            + '<span>자비지출</span></label>';
    }

    /** 구분(지출/수당/선출금) 선택 → 하위 '내용' select 재구성 */
    selectType(n, value) {
        window.expansess_inputtype = n;
        document.getElementById('inputtype').value = value;

        const presets = (document.getElementById('memsetType' + n).value || '')
            .split('|').filter((o) => o.length > 1);
        let options = "<option value=''>선택</option>";
        presets.forEach((o) => { options += `<option value='${this._attr(o)}'>${this._text(o)}</option>`; });

        this.$el.find('#userexpanceinputHolder .dsheet__fd')
            .html(this._contentCell(options, n == 1, false));
    }

    syncDriverName() {
        const sel = document.getElementById('selectdirver');
        document.getElementById('select_drivername').value = sel.options[sel.selectedIndex].text;
    }

    syncCarPlate() {
        const sel = document.getElementById('selectcar');
        document.getElementById('select_carplatetext').value = sel.options[sel.selectedIndex].text;
    }

    save() {
        var inoutsel	= document.getElementById("inputtype").value;
        var typemain	= document.getElementById("typemain").value;
        var selectdirver= parseInt(document.getElementById("selectdirver").value,10);
        var selectorder = parseInt(document.getElementById("selectorder").value,10);
        var selectcar	= parseInt(document.getElementById("selectcar").value,10);
        var jobprice = document.getElementById("jobprice").value.replace(/,/gi, "");
        jobprice	= parseInt(jobprice,10);
        var jobetc		= document.getElementById("jobetc").value;
        jobetc = jobetc.replace(/'/gi, "");
        var mynum		= document.getElementById("mynum").value;
        var select_drivername = document.getElementById("select_drivername").value;
        var select_drivernum = document.getElementById("select_drivernum").value;
        var select_carplatetext = document.getElementById("select_carplatetext").value;
        var inputmemtype = document.getElementById("inputmemtype").value;
        var mem_ownercode = document.getElementById("mem_ownercode").value;
        var datatype = document.getElementById("datatype").value;
        var expanseeditnum	= parseInt(document.getElementById("expanseeditnum").value,10);
        var regto_order = parseInt(document.getElementById("regto_order").value,10);
        if( isNaN(regto_order)){ Util.swalert("연결된 오더값이 없습니다.",""); return;}

        // 달력 피커가 항상 유효한 YYYY-MM-DD 만 넣는다 — 구 <select> 3개 시절의
        // '월 말일 초과' 검증(_maxDayOfMonth)은 불가능한 입력이 되어 사라졌다.
        var work_datevalue = document.getElementById("occureDate").value;
        if( !/^\d{4}-\d{2}-\d{2}$/.test(work_datevalue) ){ Util.swalert("지출일을 선택해 주세요",""); return; }
        if( isNaN(jobprice) ) jobprice = 0;
        if( isNaN(selectdirver) ) selectdirver = 0;
        if( isNaN(selectcar) ) selectcar = 0;
        if( inoutsel == "" || inoutsel == "0") { Util.swalert("구분을\n[지출, 수당, 선출금]중\n선택해 주세요","",""); return; }
        if( typemain == "") { Util.swalert("내용을 선택해 주세요","",""); return; }
        if( selectdirver == 0 ) { Util.swalert("기사를 선택해 주세요","",""); return; }
        if( isNaN(selectorder) ) { Util.swalert("금액이 입출금이 발생된 오더를 선택해 주세요",""); return; }
        if( jobprice == 0 ) { Util.swalert("금액을 입력해 주세요","",""); return; }

        var expace_isonme = 0;
        if( document.getElementById("expances_minset") ){
            if( document.getElementById("expances_minset").checked == true) expace_isonme = 1;
        }

        const sendData = {
            inoutsel, expanseeditnum, typemain, selectdirver, selectorder, selectcar,
            jobprice, expace_isonme, jobetc, mynum, regto_order,
            select_drivername, select_drivernum, select_carplatetext,
            inputmemtype, mem_ownercode, datatype, work_datevalue,
            regfromtype: 'app3000',
        };

        $.ajax({ type: 'POST', url: '/m/ajax/diary/cash/save', data: sendData }).done((data) => {
            if (!isNaN(parseInt(data))) {
                this.cancel();
                showDetailTable(window.lastOpen_Tab_order, window.lastOpen_Tab_tab, window.lastOpen_Tab_act, '', 'ForceToTab');
            } else {
                Util.swalert(data);
            }
        });
    }

    remove() {
        const ordernum = parseInt(document.getElementById('regto_order').value, 10) || 0;
        const editnum  = parseInt(document.getElementById('expanseeditnum').value, 10) || 0;
        if (ordernum == 0 || editnum == 0) { Util.swalert('삭제할 오더와 경비내역을 받지 못했습니다.', ''); return; }

        Util.swalert(['해당 경비내용을 삭제 할까요?', 'question'], () => {
            $.ajax({
                type: 'DELETE',
                url: '/m/ajax/diary/expense/' + editnum,
                data: { ordernum },
            }).done(() => {
                document.location.href = window.location.pathname + '?showipicknum=' + ordernum;
            });
        }, ['확인', '아니오']);
    }
}
